import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { Creators } from "../../redux/reducers/conditions.reducer";
import ModalActions from "../../redux/reducers/modal.reducer";
import { startSavePolitics } from "../../redux/epics/politics-terms-hc";
import {
  Container,
  CloseButton,
  CloseImage,
  TitleContainer,
  TitleSubContainer,
  Title,
  Scroll,
  Paragraph,
  ButtonContainer,
  Button
} from "./Styles";
import User from "../../lib/models/user.model";
import CloseButtonPymeIcon from "../../assets/images/register/close-button-pyme.png";

const Politics = ({ politicsObject, requestFrom, personType }) => {
  const [bottomReached, setBottomReached] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleScroll = (event) => {
    const node = event.target;
    const bottom = node.scrollHeight - node.scrollTop <= node.clientHeight + 20;
    if (bottom) {
      setBottomReached(true);
    }
  };
  const setListener = (node) => {
    if (node) {
      node.addEventListener("scroll", handleScroll);
    }
  };
  const acceptOnClick = () => {
    dispatch(ModalActions.setConditionalModalState(false));
    if (requestFrom === "register") {
      dispatch(Creators.setPolitics({ politicsAccepted: bottomReached }));
    } else {
      dispatch(startSavePolitics(politicsObject.id, politicsObject.version));
    }
  };

  const close = () => {
    dispatch(ModalActions.setConditionalModalState(false));
  };

  const isPyme = personType === User.type.pyme;
  const closeButtonIcon = isPyme
    ? CloseButtonPymeIcon
    : "/assets/images/close_2.png";

  return (
    <Container>
      {requestFrom === "register" && (
        <CloseButton
          id="close-button"
          onClick={close}
          data-testid="politics-close-btn"
        >
          <CloseImage alt="close" src={closeButtonIcon} />
        </CloseButton>
      )}
      <TitleContainer>
        <TitleSubContainer>
          {requestFrom === "register" ? (
            <Title personType={personType}>{t("politics.title")}</Title>
          ) : (
            <Title personType={personType}>{t("politics.title2")}</Title>
          )}
          <Scroll
            data-testid="politics-modal-content"
            id="politics-modal-content"
            ref={(ref) => {
              setListener(ref);
              if (ref) {
                const bottom =
                  ref.scrollHeight - ref.scrollTop <= ref.clientHeight + 20;
                if (bottom) {
                  setBottomReached(true);
                }
              }
            }}
          >
            <Paragraph>{politicsObject.text}</Paragraph>
          </Scroll>
        </TitleSubContainer>
        <ButtonContainer personType={personType}>
          <Button
            id="continue-button"
            data-testid="politics-accept-btn"
            disabled={!bottomReached}
            onClick={acceptOnClick}
            personType={personType}
          >
            {t("politics.acceptButton")}
          </Button>
        </ButtonContainer>
      </TitleContainer>
    </Container>
  );
};

Politics.propTypes = {
  politicsObject: PropTypes.shape({
    id: PropTypes.number,
    version: PropTypes.string,
    url: PropTypes.string,
    text: PropTypes.string
  }).isRequired,
  requestFrom: PropTypes.string.isRequired,
  personType: PropTypes.string.isRequired
};

export default Politics;
